/** Consumer-facing user (kept for shared type compat) */
export interface User {
    id: string;
    name: string;
    email: string;
    totalEarnings: number;
    pendingEarnings: number;
    points: number;
    completedTasks: string[];
    activeClaims: string[];
}

/** Advertiser user — the actual shape returned by /advertisers/auth */
export interface AdvertiserUser {
    id: string;
    email: string;
    name?: string;
    displayName?: string;
    org_id?: string;
    role?: 'advertiser' | 'admin' | string;
    billing_status?: 'active' | 'inactive' | 'suspended' | string;
    billing_threshold?: number;
    current_unbilled_spend?: number;
    status?: UserStatus;
    created_at?: string;
    [key: string]: unknown; // allow extra fields from API without losing type safety
}
    
export enum UserStatus {
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
  blocked = 'blocked',
}

export const USER_STATUS_LABELS: Record<UserStatus, string> = {
  [UserStatus.pending]: 'Pending Approval',
  [UserStatus.approved]: 'Approved',
  [UserStatus.rejected]: 'Rejected',
  [UserStatus.blocked]: 'Blocked',
};

export const USER_STATUS_COLORS: Record<UserStatus, string> = {
  [UserStatus.pending]: 'bg-yellow-900/80 text-yellow-200',
  [UserStatus.approved]: 'bg-emerald-900/80 text-emerald-200',
  [UserStatus.rejected]: 'bg-red-900/80 text-red-200',
  [UserStatus.blocked]: 'bg-gray-800 text-gray-400',
};